<template>
  <q-drawer
    v-model="drawer"
    :width="232"
    :show-if-above="false"
    :breakpoint="500"
    bordered
    content-class="bg-white rel"
  >
    <q-scroll-area class="fit flex">
      <div class="side-list">
        <div v-for="(item, index) in menuHandler" :key="index">
          <div class="inner-side" v-if="item.children">
            <div class="expansion-side" @click="menuManager(item.label, index)">
              <i :class="item.icon"></i>
              <div v-text="item.label"></div>
              <i :class="item.label !== name ? 'fas fa-chevron-down fa-fw' : 'fas fa-chevron-up fa-fw'"></i>
            </div>
            <transition-group name="list" tag="div">
              <div v-if="name === item.label" :key="name">
                <div v-for="j in item.children" :key="j.route" v-if="j.show">
                  <router-link
                    v-if="j.label !== 'Zubie' && !j.isLink"
                    :disabled="j.disable"
                    :event="j.disable ? '' : 'click'"
                    style="text-decoration: none"
                    :to="j.route"
                    :class="$route.name === j.name ? 'side-list-items inner active' : 'side-list-items inner'"
                  >
                    <i :class="j.icon"></i>
                    <div :style="index === 9 ? 'margin-left:15px' : ''">
                      {{ j.label }}
                    </div>
                    <q-tooltip
                      anchor="center right"
                      self="center left"
                      :content-class="{
                        'bg-gray': true,
                        'bg-primary': j.name === $route.name
                      }"
                      content-style="font-size: 14px;height:48px;align-items:center;justify-content:center;display:flex;font-weight:bold;color:#fff"
                      :offset="[10, 10]"
                      v-if="j.tooltip"
                    >
                      {{ j.tooltip }}
                    </q-tooltip>
                  </router-link>
                  <div v-else>
                    <a
                      v-if="j.isChatbot"
                      target="_blank"
                      rel="noopener"
                      style="text-decoration:none; cursor:pointer"
                      class="side-list-items inner"
                      @click.prevent="openChatbot"
                    >
                      <i :class="j.icon"></i>
                      <div>{{ j.label }}</div>
                      <q-tooltip
                        anchor="center right"
                        self="center left"
                        content-class="bg-gray"
                        content-style="font-size:14px;height:48px;align-items:center;justify-content:center;display:flex;font-weight:bold;color:#fff"
                        :offset="[10, 10]"
                        v-if="j.tooltip"
                      >
                        {{ j.tooltip }}
                      </q-tooltip>
                    </a>
                    <a
                      v-else
                      target="_blank"
                      style="text-decoration:none"
                      class="side-list-items inner"
                      :href="j.route"
                      v-show="j.show"
                    >
                      <i :class="j.icon"></i>
                      <img
                        v-if="j.label !== 'Zubie'"
                        width="20"
                        :src="require(`@/assets/${j.label}.png`)"
                        :alt="j.label"
                      />
                      <div :style="index === 9 ? 'margin-left:15px' : ''">
                        {{ j.label }}
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
          <div v-else @click="menuManager(item.label, index)">
            <router-link
              style="text-decoration: none"
              :to="item.route"
              :class="$route.name === item.name ? 'side-list-items active' : 'side-list-items'"
              :key="index"
            >
              <i :class="item.icon"></i>
              <div v-text="item.label"></div>
            </router-link>
          </div>
        </div>
        <div class="powered-by">
          <img :src="manheim" style="height:50px !important;width:75px" alt="" />
          <img :src="blackbook" style="height:50px !important;width:75px" alt="" />
        </div>
      </div>
    </q-scroll-area>
  </q-drawer>
</template>

<script>
import manheim from '../assets/manheim.svg'
import blackbook from '../assets/blackbook.png'

export default {
  data() {
    return {
      menuList: [
        {
          label: 'Dashboard',
          name: 'home',
          route: '/',
          icon: 'fas fa-chart-area fa-fw',
          show: true
        },
        // {
        //   label: "Operation Reports",
        //   route: "/operation-reports",
        //   name: "operation-reports",
        //   icon: "far fa-file-alt fa-fw",
        // },
        {
          label: 'Fleet View',
          icon: 'fas fa-hand-holding-usd fa-fw',
          show: true,
          children: [
            {
              route: '/summary-current',
              name: 'summary-current',
              label: 'Total Value',
              show: true,
              tooltip: 'Management summary report of total fleet’s current values'
            },
            {
              route: '/vehicle-advanced',
              name: 'vehicle-advanced',
              label: 'Value by Vehicle',
              show: true,
              tooltip: 'List of Current Fleet information including MMR & Pay-off Information'
            },
            {
              route: '/vehicle-class-performance',
              name: 'vehicle-class-performance',
              label: 'Class Performance',
              show: false,
              tooltip: 'List of Vehicle Class Performance'
            }
          ]
        },
        {
          label: 'Future Projection',
          icon: 'fas fa-angle-double-right fa-fw',
          show: false,
          children: [
            {
              route: '/summary-future',
              name: 'summary-future',
              // icon: "fas fa-asterisk fa-fw",
              label: 'Total Value',
              show: true,
              tooltip: 'Management summary report of total fleet’s future values.'
            },
            {
              route: '/future-value',
              name: 'future-value',
              // icon: "fas fa-info-circle fa-fw",
              label: 'Value by Vehicle',
              show: true,
              tooltip: 'Showing Vehicle’s Future Market Value and Pay-off Amount trend graphic and values.'
            }
          ]
        },
        {
          label: 'Projected Rev/Loss',
          icon: 'fas fa-comments-dollar fa-fw',
          route: '/projected-rev-loss',
          name: 'projected-rev-loss',
          show: false
        },
        {
          label: 'Calculators',
          icon: 'fas fa-calculator fa-fw',
          show: true,
          children: [
            {
              label: 'Financial Calculator',
              route: '/calculator',
              name: 'calculator',
              show: true,
              tooltip: 'Finance calculator with different options.'
            },
            {
              label: 'Diminished Value Calculator',
              route: '/dimished-value-calculator',
              name: 'dimished-value-calculator',
              show: true,
              tooltip: 'Diminished Value Calculator'
            }
          ]
        },
        {
          label: 'Manheim Valuation',
          icon: 'fab fa-searchengin fa-fw',
          show: true,
          children: [
            {
              label: 'Search',
              route: '/manheim-search',
              name: 'manheim-search',
              show: true,
              tooltip: 'Manheim search.'
            },
            {
              label: 'Batch',
              route: '/manheim-batch',
              name: 'manheim-batch',
              show: true,
              tooltip: 'Manheim batch.'
            }
          ]
        },
        {
          label: 'Historical Trend',
          icon: 'fas fa-table fa-fw',
          route: '/historical-trend',
          name: 'historical-trend',
          show: true
        },
        {
          route: '/for-sale',
          name: 'for-sale',
          label: 'For Sale',
          icon: 'fas fa-comments-dollar fa-fw',
          show: true,
          tooltip: 'List of vehicles that are for sale.'
        },
        {
          label: 'Apps',
          icon: 'fas fa-border-all fa-fw',
          show: true,
          children: [
            {
              label: 'AI Assistant',
              icon: 'fas fa-robot fa-fw',
              route: '#',
              name: 'ai-assistant',
              show: true,
              isLink: true,
              isChatbot: true,
              tooltip: 'Talk to your fleet data in plain English'
            },
            {
              label: 'Zubie',
              icon: 'fas fa-link fa-fw',
              route: 'https://app.zubie.com/',
              name: 'zubie',
              show: true
            },
            {
              label: 'Accident Report',
              icon: 'fas fa-car-crash fa-fw',
              route: '/accident-report',
              name: 'accident-report',
              show: true
            },
            {
              label: 'RateHighway',
              icon: null,
              route: 'https://www.ratehighway.com/',
              name: 'rate-highway',
              show: true,
              isLink: true
            },
            {
              label: 'TSD',
              icon: null,
              route: 'https://tsdweb.com/',
              name: 'tsd',
              show: true,
              isLink: true
            },
            {
              label: 'Wheels',
              icon: null,
              route: 'https://wheelsys.com/',
              name: 'wheels',
              show: true,
              isLink: true
            },
            {
              label: 'FleetIT',
              icon: null,
              route: 'https://fleetit.co/',
              name: 'fleet-it',
              show: true,
              isLink: true
            }
          ]
        }
        // {
        //   label: "History Reports",
        //   icon:'far fa-clone fa-fw',
        //   name:'reports',
        //   route:'/reports',
        //   show: false,
        // },
      ],
      manheim,
      blackbook
    }
  },
  mounted() {
    const { name } = this.$route
    if (name === 'companies' || name === 'vehicles' || name === 'tags' || name === 'mileage' || name === 'profile')
      this.name = 'Profile'
    else if (name === 'calculator' || name === 'dimished-value-calculator') this.name = 'Calculators'
    else if (name === 'future-value' || name === 'summary-future') this.name = 'Future Projection'
    else if (name === 'vehicle-advanced' || name === 'summary-current' ||
      name === 'vehicle-class-performance') this.name = 'Fleet View'
    else if (name === 'projected-rev-loss') this.name = 'Projected Rev/Loss'
    else if (name === 'manheim-search' || name === 'manheim-batch') this.name = 'Manheim Valuation'
    else if (name === 'historical-trend') this.name = 'Historical Trend'
    else this.name = name
  },
  methods: {
    openChatbot() {
      // P36: SSO into the chatbot using the user's current FMS JWT.
      // The chatbot validates the token, sets its own session cookie, and
      // redirects to "/" — no extra credentials, same scope (companies).
      const raw = localStorage.getItem('token') || ''
      const jwt = raw.replace(/^Bearer\s+/i, '').trim()
      if (!jwt) {
        if (this.$q && this.$q.notify) {
          this.$q.notify({ type: 'warning', message: 'Please sign in first.' })
        }
        return
      }
      const base = process.env.VUE_APP_CHATBOT_URL || 'https://chatbot.cosmosboard.com'
      const url = `${base}/sso?fms_token=${encodeURIComponent(jwt)}`
      window.open(url, '_blank', 'noopener')
    },
    menuManager(name, _) {
      if (name === this.name) {
        if (
          (this.name === 'Profile' && name === 'Companies') ||
          name === 'Custom Tag' ||
          name === 'Mileage' ||
          name === 'Vehicles' ||
          name === 'User Settings'
        )
          return true
        else if (
          (this.name === 'Calculators' && name === 'Financial Calculator') ||
          name === 'Diminished Value Calculator'
        )
          return true
        else this.name = null
      } else {
        if (
          (this.name === 'Profile' && name === 'Companies') ||
          name === 'Custom Tag' ||
          name === 'Mileage' ||
          name === 'Vehicles' ||
          name === 'User Settings'
        )
          return true
        else if (
          (this.name === 'Calculators' && name === 'Financial Calculator') ||
          name === 'Diminished Value Calculator'
        )
          return true
        else this.name = name
      }
    }
  },
  computed: {
    menuHandler() {
      return this.menuList.filter(({ show }) => show)
    },
    user() {
      return this.$store.state.profile.user
    },
    name: {
      get() {
        return this.$store.state.layout.name
      },
      set(val) {
        this.$store.commit('layout/SET_NAME', val)
      }
    },
    drawer: {
      get() {
        return this.$store.state.layout.drawer
      },
      set(val) {
        this.$store.commit('layout/SET_DRAWER', val)
      }
    }
  },
  watch: {
    user: {
      deep: true,
      immediate: true,
      handler(n, _) {
        this.menuList[2].show = n.is_future_value || false
        this.menuList[3].show = n.is_projected_rev_loss || false
        this.menuList[1].children[2].show = n.is_class_performances || false
        // this.menuList[6].show = n.is_history_reports || false;
      }
    }
  }
}
</script>

<style lang="scss">
.rel {
  position: relative;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.powered-by {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  width: 100%;
  flex: 1;
  justify-content: center;
  margin-bottom: 20px;
  img {
    width: 100px;
    height: 75px;
  }
}
.side-list {
  display: flex;
  flex-flow: column nowrap;
  min-height: calc(100vh - 70px);
  flex: 1;
  .side-list-items,
  .expansion-side {
    display: flex;
    flex-flow: row nowrap;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px 15px;
    font-size: 1rem;
    justify-content: flex-start;
    align-items: center;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
      transition: 500ms all;
    }
    cursor: pointer;
    i {
      color: #666666;
    }
    div {
      margin-left: 10px;
      color: #666666;
      margin-top: 3px;
      font-weight: 500;
      flex: 1;
    }
  }
  .inner {
    padding-left: 35px !important;
  }
  .active {
    &:hover {
      background: rgba(0, 0, 0, 0.1);
      transition: 500ms all;
    }
    cursor: pointer;
    i {
      color: #027be3;
    }
    div {
      color: #027be3;
      margin-top: 3px;
      font-weight: 500;
    }
  }
  .hoverless-active {
    i {
      color: #027be3;
    }
    div {
      color: #027be3;
      margin-top: 3px;
      font-weight: 500;
    }
  }
}
</style>
